import { useEffect, useState } from "react";
import AccordionComponent from "../../../../components/Accordion";
import Button from "../../../../components/Button";
import Input from "../../../../components/Input";
import InputSelect from "../../../../components/Input-select";
import Title from "../../../../components/Title";
import { TableComponent, TH, THeadTR } from "../../../../components/Table v2";
import { ACCESS, MOCK } from "../../constants";
import "./index.scss";
import { IconEye, IconEyeOutline, IconLeftArrowVersion2 } from "../../../../icons";
import { useHistory } from "react-router-dom";
import Spinner from "../../../../components/Spinner";
import { getProfileById, postProfile, updateProfile } from "../../service";
import useAuthData from "../../../../hook/useAppData";
import { toastError } from "../../../../components/Toast";

export default function FormProfile({ match }) {
  const { token } = useAuthData();
  const [profile, setProfile] = useState<{ name: string; ids: number[] }>({ name: "", ids: [] });
  const [selectedDefault, setSelectedDefault] = useState<number>(0);
  const [accordion, setAccordion] = useState<string[]>();
  const [createOrUpdate, setCreateOrUpdate] = useState<"create" | "update">("create");

  const [needSpinner, setNeedSpinner] = useState(true);

  const history = useHistory();

  useEffect(() => {
    if (match?.params?.id) getPermissionOfThisProfile();
    else getCheckeds();
  }, []);

  async function getPermissionOfThisProfile() {
    setCreateOrUpdate("update");
    const res = await getProfileById({ token, id: match?.params?.id });
    setProfile({ name: res.name, ids: res.accessId || [] });
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }

  function getCheckeds() {
    setCreateOrUpdate("create");
    setNeedSpinner(false);
    let list: any[] = [];
    MOCK.map((mock) => {
      mock.screens.map((screen) => {
        screen.options.map((option) => {
          if (option.checked) list.push(option.id);
        });
      });
    });

    setProfile({ ...profile, ids: list });
  }

  async function handleSaveClick() {
    if (!profile.name) return toastError("Nome do Perfil é obrigatório");
    const req = {
      name: profile.name,
      access_id: [...new Set(profile.ids)],
    };
    let responseOfRequest = undefined;
    if (createOrUpdate === "create") responseOfRequest = await postProfile({ token, body: req });
    else responseOfRequest = await updateProfile({ token, body: req, id: match?.params?.id });
    if (!responseOfRequest?.ok) return toastError(`Não foi possivel ${createOrUpdate === "create" ? "Criar" : "Editar"} o perfil`);
    exitForm();
  }

  function handleClickCheckBox(id: number) {
    const newList = verefyIdIfIsHomePageOption(id);
    setProfile({ ...profile, ids: newList });
  }

  function verefyIdIfIsHomePageOption(id: number) {
    let listIds: number[] = [];
    if (profile?.ids?.includes(id)) listIds = profile?.ids?.filter((idChecked) => idChecked !== id);
    else listIds = profile?.ids?.concat([id]);
    if (id === ACCESS.HOMEPAGE_graphic && profile?.ids?.includes(ACCESS.HOMEPAGE_cards))
      listIds = listIds?.filter((item) => item !== ACCESS.HOMEPAGE_cards);
    if (id === ACCESS.HOMEPAGE_cards && profile?.ids?.includes(ACCESS.HOMEPAGE_graphic))
      listIds = listIds?.filter((item) => item !== ACCESS.HOMEPAGE_graphic);
    if (id === ACCESS.ROUTINE_APPOINTMENT_consolidate && !profile?.ids?.includes(ACCESS.ROUTINE_APPOINTMENT_read))
      listIds.push(ACCESS.ROUTINE_APPOINTMENT_read);
    if (id === ACCESS.ROUTINE_APPOINTMENT_read && profile?.ids?.includes(ACCESS.ROUTINE_APPOINTMENT_consolidate))
      listIds = listIds?.filter((item) => item !== ACCESS.ROUTINE_APPOINTMENT_consolidate);
    if (id === ACCESS.PROJECT_write && !profile?.ids?.includes(ACCESS.PROJECT_read)) listIds.push(ACCESS.PROJECT_read);
    if (id === ACCESS.PROJECT_read && profile?.ids?.includes(ACCESS.PROJECT_write))
      listIds = listIds?.filter((item) => item !== ACCESS.PROJECT_write);

    return listIds;
  }

  const options = {
    1: handleAdminDefault,
    2: handleCollaborator,
  };

  function handleChangeDefaultOption(idSelected: number) {
    options[idSelected]();
  }
  function handleCollaborator() {
    const ids = getIdsCollaborator();
    setProfile({ ...profile, ids });
    setAccordion(["Profissionais", "Time Sheet", "Nota Fiscal"]);
  }

  function getIdsCollaborator() {
    let list = [];
    MOCK?.forEach((mock) => {
      mock?.screens?.forEach((screen) => {
        if (screen.name === "Dados Cadastrais") screen.options?.forEach((option) => option.name === "Auto Perfil" && list.push(option.id));
        if (screen.name === "Time Sheet") screen.options?.forEach((option) => list.push(option.id));
        if (screen.name === "Nota Fiscal") screen.options?.forEach((option) => list.push(option.id));
      });
    });
    return list;
  }

  function handleAdminDefault() {
    const ids = getIdsAdmin();
    const modules = getModulesAdmin();
    setProfile({ ...profile, ids });
    setAccordion(modules);
  }

  function getIdsAdmin() {
    let list = [];
    MOCK?.forEach((mock) => {
      mock?.screens?.forEach((screen) => {
        screen.options?.forEach((option) => {
          if (option.id !== ACCESS.HOMEPAGE_cards && option.id !== ACCESS.HOMEPAGE_graphic) list?.push(option.id);
        });
      });
    });
    return list;
  }

  function getModulesAdmin() {
    let list = [];
    MOCK.forEach((mock) => {
      list.push(mock.module);
    });
    return list;
  }

  function setAccordionValues({ module }) {
    if (!accordion) return setAccordion([module]);
    if (accordion?.includes(module)) return setAccordion(accordion?.filter((nameAccordion) => nameAccordion !== module));
    return setAccordion((oldValues) => [...oldValues, module]);
  }

  function ClearData() {
    setAccordion(undefined);
    setSelectedDefault(0);
    setProfile({ name: "", ids: [] });
  }

  function exitForm() {
    history.goBack();
  }

  return (
    <>
      <Spinner status={needSpinner}>
        <div className="container">
          <div>
            <Title
              title={
                <span className="flex items-center">
                  <span onClick={exitForm} className="cursor-pointer mr-2">
                    {IconLeftArrowVersion2}
                  </span>{" "}
                  {createOrUpdate === "create" ? "Cadastrar Perfil" : "Atualizar Perfil"}
                </span>
              }
            />
            <div className="w-full h-auto bg-white rounded-xl flex p-4 gap-3">
              <Input
                className="w-20"
                name="profile"
                label={"Nome do Perfil"}
                placeholder={"Digite o nome do perfil"}
                value={profile?.name}
                setValue={(e) => setProfile({ ...profile, name: e.target.value })}
                required={true}
                autoFocus
              />
              <InputSelect
                name={""}
                label={"Definir Permissões"}
                className=""
                list={[
                  { id: 1, name: "Permissão Total" },
                  { id: 2, name: "Permissão Parcial" },
                ]}
                onChange={(e) => {
                  setSelectedDefault(+e.target.value);
                  handleChangeDefaultOption(+e.target.value);
                }}
                value={selectedDefault}
              />
              <div className="flex items-end mb-3">
                <Button onClick={ClearData} className="bg-primary h-16 mb-1">
                  Limpar
                </Button>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <TableComponent className="rounded-xl">
              <THeadTR>
                <TH className="justify-start">
                  <div className="flex justify-between w-full">
                    <span className="flex items-center text-center gap-3">
                      Módulos{" "}
                      <span
                        onClick={() => setAccordion(accordion?.length ? undefined : getModulesAdmin())}
                        className="cursor-pointer text-primary underline"
                      >
                        {accordion?.length ? IconEyeOutline : IconEye}
                      </span>
                    </span>
                    <span className="mr-16">Permissões em cada tela</span>
                  </div>
                </TH>
              </THeadTR>
              <tbody>
                {MOCK?.map((mock) => {
                  return (
                    <tr className="row-accordion h-28 border-b-4 border-background">
                      <AccordionComponent
                        expanded={!!accordion?.includes(mock.module)}
                        onClickFather={() => setAccordionValues(mock)}
                        father={
                          <div
                            className={`w-full flex pl-4 mt-6 justify-between text-2xl font-medium border-background ${
                              !!accordion?.includes(mock.module) && "shadow-xl"
                            }`}
                          >
                            <div className="flex gap-4">
                              <span className="-mt-1 icon-accordion-module">{mock?.icon}</span> <span>{mock?.module}</span>
                            </div>
                            <span className="gap-8">
                              {mock?.screens?.map((screen, index) => {
                                return (
                                  <span className={`font-bold  ${index % 2 === 0 ? "text-primary" : "text-secondary"}`}>
                                    {index ? "  -  " : ""}
                                    {screen?.name} - {screen?.options?.filter((option) => profile?.ids?.includes(option?.id))?.length} de{" "}
                                    {screen?.name === "Página Inicial" ? 1 : screen?.options?.length}
                                  </span>
                                );
                              })}
                            </span>
                          </div>
                        }
                        icon={true}
                        status={false}
                        childrenClassName="flex justify-center  rounded-3xl"
                      >
                        <div className="div-table-form w-11/12 rounded-xl p-4 m-4 text-textPrimary">
                          <table className="w-full shadow-2xl">
                            <THeadTR>
                              <TH>
                                <span className="flex justify-start pl-2">Tela</span>
                              </TH>
                              <TH>
                                <span className="flex justify-center -ml-16">Permissões</span>
                              </TH>
                            </THeadTR>
                            <tbody>
                              {mock?.screens?.map((screen, index, screens) => {
                                return (
                                  <tr className={` ${index + 1 !== screens?.length && "border-b-2 border-background"} `}>
                                    <td>{screen?.name}</td>
                                    <td className=" p-0 mb-0 h-20">
                                      <div className="flex p-4 justify-evenly bg-white text-textPrimary">
                                        {screen?.options?.map((option) => {
                                          return (
                                            <div className=" flex items-center w-1/5 gap-4 bg-white text-textPrimary">
                                              <input
                                                name="profiles"
                                                type="checkbox"
                                                className="border border-newPrimary cursor-pointer"
                                                checked={!!profile?.ids?.includes(option.id)}
                                                onClick={(e: any) => handleClickCheckBox(+e.target.value)}
                                                id={`${option?.id}`}
                                                value={option?.id}
                                              />
                                              <label className="inline-block min-w-max">{option?.name}</label>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </AccordionComponent>
                    </tr>
                  );
                })}
              </tbody>
            </TableComponent>
            <div className="justify-end gap-2">
              <Button onClick={exitForm} className="bg-secondary mt-11">
                Cancelar
              </Button>
              <Button onClick={handleSaveClick} className="bg-primary mt-11">
                {createOrUpdate === "create" ? "Criar" : "Atualizar"}
              </Button>
            </div>
          </div>
        </div>
      </Spinner>
    </>
  );
}
